import { ModelResource } from './resource';
import { DisputeItem } from '../models';

export class DisputeItems extends ModelResource<DisputeItem> {
  model = DisputeItem;

  resourcePath = 'v1/dispute-items';
}
